import React, { lazy, Suspense } from "react";
import Sidebar from "../../Module/sidebar";
import { Route, Routes } from "react-router";

import { useSelector } from "react-redux";
import {
  MarketingPanelEmpSidebarData,
  MarketingPanelSidebarData,
} from "../../Module/marketingPanelSidebarData";
import Loading from "../../Component/Loading";
import AddStoryType from "../SMTeamPanel/StoryType/addStoryType";
import EditDeleteStoryType from "../SMTeamPanel/StoryType/editStoryType";
import EditExamSrcVideo from "../SMTeamPanel/ExamSourceVideo/editExamSrcVideo";
import CreateExamSrcVideo from "../SMTeamPanel/ExamSourceVideo/createExamSourceVideo";
import StudentCouponAdd from "../CXOPanel/studentCouponCode/studentCouponAdd";
import StudentCouponEdit from "../CXOPanel/studentCouponCode/studentCouponEdit";
import AddCampaignID from "./CampaignID/addCampaignID";

// Movements of Meeting (same pages as the other panels)
const MovementsOfMeeting = lazy(() =>
  import("../CategoryPanel/MovementsOfMeeting/movementsOfMeeting"),
);
const EditMovementsOfMeeting = lazy(() =>
  import("../CategoryPanel/MovementsOfMeeting/editMovementsOfMeeting"),
);
/*********************************************************** */

const AddCampaign = lazy(
  () => import("../ConfigurationData/Campaign/addCampaign"),
);
const EditDeleteCampaign = lazy(
  () => import("../ConfigurationData/Campaign/editDeleteCampaign"),
);
const SendPushNotification = lazy(
  () => import("../ConfigurationData/sendPushNotification"),
);
const WhatsappMessageAnalysis = lazy(
  () => import("../CXOPanel/whatsappmessageAnalysis"),
);
const PaidPageAnalysis = lazy(() => import("../CXOPanel/paidPageAnalysis"));
const PushNotificationAnalysis = lazy(
  () => import("../CXOPanel/pushNotification/pushNotificationAnalysis"),
);
const AddExamPopUpNotification = React.lazy(
  () => import("../AdminPanel/ExamPopUpNotification/addExamPopUpNotification"),
);

const EditExamPopUpNotification = React.lazy(
  () => import("../AdminPanel/ExamPopUpNotification/editExamPopUpNotification"),
);

const AddFestiveBanner = React.lazy(
  () => import("../AdminPanel/FestiveBanner/addFestiveBanner"),
);
const AddAllPopup = React.lazy(() => import("../allPopup/addAllPopup"));
const EditPopup = React.lazy(() => import("../allPopup/editPopup"));
const AddMailCampaign = lazy(
  () => import("../ConfigurationData/EmailCampaign/addMailCampaign"),
);
const EditDeleteEmailCamp = lazy(
  () => import("../ConfigurationData/EmailCampaign/editDeleteEmailCamp"),
);
const AddwhatsAppCampaign = lazy(
  () => import("../ConfigurationData/whatsAPPCampaign/addWhatsAppCampaign"),
);
const VerifyuserDetails = lazy(
  () => import("../ConfigurationData/VerifyuserDetails/VerifyuserDetails"),
);
const UserKycDetails = lazy(
  () => import("../ConfigurationData/userKyc/userKyc"),
);
const ImageComparisonAndSwap = lazy(
  () => import("./ImageComparison&Swap/ImageComparison&Swap"),
);
const CampaignAnalyticsModern = lazy(
  () => import("./CampaignAnalytics/CampaignAnalytics"),
);
const EditDeleteCampaignID = lazy(
  () => import("./CampaignID/EditDeleteCampaignID"),
);
const EditDeleteNotification = lazy(
  () => import("../DataEntryPanel/editDeleteNotification"),
);
const CreateNotification = lazy(
  () => import("../DataEntryPanel/createNotification"),
);
const WhatsAppTemplateStatus = lazy(
  () =>
    import("../ConfigurationData/WhatsAppTemplateStatus/whatsAppTemplateStatus"),
);
const TargetingExams = lazy(() => import("./TargetingExams/TargetingExams"));
const LoginBannerAdd = lazy(() => import("./LoginBanner/loginBannerAdd"));

/*********************************************************** */
const ProductDevelopmentDashboard = () => {
  const { loginType } = useSelector((state) => ({
    loginType: state.Auth?.loginType,
  }));

  return (
    <div className="AppBox">
      <Sidebar
        data={
          loginType === 2
            ? MarketingPanelEmpSidebarData
            : MarketingPanelSidebarData
        }
      />
      <div className="dashboard">
        {
          <Suspense
            fallback={
              <div className="border p-1">
                <Loading />
              </div>
            }
          >
            <Routes>
              <Route path="/" element={<AddCampaignID />} />
              <Route path="addCampaignID" element={<AddCampaignID />} />
              <Route
                path="editDeleteCampaignID"
                element={<EditDeleteCampaignID />}
              />
              <Route
                path="campaignAnalysis"
                element={<CampaignAnalyticsModern />}
              />
              <Route path="addCampaign" element={<AddCampaign />} />
              <Route
                path="editDeleteCampaign"
                element={<EditDeleteCampaign />}
              />
              <Route
                path="sendPushNotification"
                element={<SendPushNotification />}
              />
              <Route
                path="whatsappmessageAnalysis"
                element={<WhatsappMessageAnalysis />}
              />
              <Route path="paidPageAnalysis" element={<PaidPageAnalysis />} />
              <Route
                path="pushNotificationAnalysis"
                element={<PushNotificationAnalysis />}
              />
              <Route
                path="addExamPopUpNotification"
                element={<AddExamPopUpNotification />}
              />
              <Route
                path="editExamPopUpNotification"
                element={<EditExamPopUpNotification />}
              />
              <Route path="addPopUp" element={<AddAllPopup />} />
              <Route path="editPopUp" element={<EditPopup />} />
              <Route path="addFestiveBanner" element={<AddFestiveBanner />} />
              <Route path="addMailCampaign" element={<AddMailCampaign />} />
              <Route
                path="editDeleteEmailCamp"
                element={<EditDeleteEmailCamp />}
              />
              <Route path="addStoryType" element={<AddStoryType />} />
              <Route path="editStoryType" element={<EditDeleteStoryType />} />
              <Route path="addExamSrcVideo" element={<CreateExamSrcVideo />} />
              <Route path="editExamSrcVideo" element={<EditExamSrcVideo />} />
              <Route path="/studentCouponAdd" element={<StudentCouponAdd />} />
              <Route
                path="/studentCouponEdit"
                element={<StudentCouponEdit />}
              />
              <Route
                path="addWhatsAppCampaign"
                element={<AddwhatsAppCampaign />}
              />
              <Route path="verifyuserDetails" element={<VerifyuserDetails />} />
              <Route path="userKycDetails" element={<UserKycDetails />} />
              <Route
                path="imageComparison&Swap"
                element={<ImageComparisonAndSwap />}
              />
              <Route
                path="createNotification"
                element={<CreateNotification />}
              />
              <Route
                path="editDeleteNotification"
                element={<EditDeleteNotification />}
              />
              <Route path="targetingExam" element={<TargetingExams />} />
              <Route path="loginBannerAdd" element={<LoginBannerAdd />} />
              <Route
                path="whatsAppTemplateStatus"
                element={<WhatsAppTemplateStatus />}
              />
              <Route path="movementsOfMeeting" element={<MovementsOfMeeting />} />
              <Route path="editMovementsOfMeeting" element={<EditMovementsOfMeeting />} />
            </Routes>
          </Suspense>
        }
      </div>
    </div>
  );
};

export default ProductDevelopmentDashboard;
